<template>
    <div class="col-12" v-if="variantsWithEan.length && currentVariantData && currentVariantData.ean">
        <!-- One button per variant: the single cc.js widget reads the EAN from the clicked button's data-ean -->
        <button
            v-for="variant in variantsWithEan"
            v-show="variant.id === activeVariant"
            :key="variant.id"
            :data-ean="variant.ean"
            type="button"
            class="productdetail-retailer-btn cc-fi-button btn btn-secondary btn-lg w-100 position-relative"
        >
            <ph-shopping-cart weight="bold" aria-hidden="true" />
            <span class="mb-0 ms-1">{{ $t('product_detail.add_to_cart') }}</span>
        </button>
    </div>
</template>

<script>
import { EventBus } from "../../api/eventBus.ts";
import { PhShoppingCart } from "phosphor-vue";

export default {
    components: {
        PhShoppingCart
    },
    props: {
        variantJson: {
            type: String,
            required: true,
        },
        site:{
            type: String,
            required: true,
        }
    },
    data() {
        return {
            variants: [],
            activeVariant: null,
        };
    },
    computed: {
        variantsWithEan() {
            return this.variants.filter(variant => variant.ean);
        },
        currentVariantData() {
            return this.activeVariant !== null
                ? this.variants.find(variant => variant.id === this.activeVariant)
                : null;
        },
    },
    created() {
        this.variants = JSON.parse(this.variantJson);
        EventBus.$on("variant-selected", this.changeVariant);
    },
    mounted() {
        if (!this.variantsWithEan.length) return;

        // Keep the widget off the critical path: load it once the page and its assets are done
        const schedule = () => 'requestIdleCallback' in window
            ? window.requestIdleCallback(this.loadScript, { timeout: 2000 })
            : setTimeout(this.loadScript, 0);

        if (document.readyState === 'complete') {
            schedule();
        } else {
            window.addEventListener('load', schedule, { once: true });
        }
    },
    beforeDestroy() {
        EventBus.$off("variant-selected", this.changeVariant);

        document.getElementById('cci-widget')?.remove();
        document.getElementById('cci-root')?.remove();
    },
    methods: {
        changeVariant(id) {
            this.activeVariant = id;
        },
        loadScript() {
            // cc.js loads its widget as an ES module, which only ever runs once per page
            if (this._isDestroyed || document.getElementById('cci-widget')) return;

            const isDefault = this.site === 'default';
            const isBenelux = ['default', 'be-fr', 'be-nl', 'nl-nl', 'nl'].includes(this.site);

            // Derive locale and display language from site code
            const lang = isDefault ? 'nl' : this.site.slice(-2);
            const region = isDefault ? 'BE' : this.site.slice(0, 2).toUpperCase();

            const script = document.createElement('script');
            Object.assign(script.dataset, {
                // Required to initialise; clicks use the data-ean of the clicked button instead
                ean: this.variantsWithEan[0].ean,
                subid: 'website',
                widgetid: 'gRwADMvo4z_033743a0-4d3d-11ec-bbba-13a119b875b118',
                locale: `${lang}-${region}`,
                displaylanguage: lang,
                token: isBenelux
                    ? '79b8233a17747a88113ed06899257fb18e4e66a7'
                    : '90ef747fee2d5bfd120b829b70b18e3dcc4c402c',
                trackingid: isBenelux
                    ? `POS-${this.site}-CommerceConnector`
                    : 'POS-DE-CommerceConnector',
                eventgtm: isBenelux
                    ? `POS-${this.site}-CommerceConnector`
                    : 'POS-DE-CommerceConnector',
            });

            script.type = 'text/javascript';
            script.src = 'https://fi-v2.global.commerce-connector.com/cc.js';
            script.id = 'cci-widget';

            document.body.appendChild(script);
        }
    }
};
</script>
